import React, { useMemo, useState } from 'react';

/**
 * 报价计算器：直接嵌入 public 目录下的 wp-01.html
 */
const QuotationCalculator = () => {
  // 以当前应用所在目录为基础，拼出 wp-01.html 的访问地址
  const src = useMemo(() => {
    if (process.env.NODE_ENV == 'development') {
      let { origin, pathname } = window.location;
      let dir = pathname.endsWith('/') ? pathname : `${pathname}/`;
      return `${origin}${dir}wp-01.html`;
    }
    return '/wp-01.html';
  }, []);

  const [loading, setLoading] = useState(true);

  return (
    <div
      style={{
        background: '#fff',
        borderRadius: 4,
        padding: 0,
        overflow: 'hidden',
      }}
    >
      {loading && (
        <div
          style={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
        >
          加载中...
        </div>
      )}
      <iframe
        title="报价计算"
        src={src}
        style={{
          width: '100%',
          height: 'calc(100vh - 140px)',
          border: 0,
          display: loading ? 'none' : 'block',
        }}
        onLoad={() => setLoading(false)}
      />
    </div>
  );
};

export default QuotationCalculator;